import { render, staticRenderFns } from "./DedicatedNumberPaymentNotification.vue?vue&type=template&id=442d5e57&scoped=true&"
import script from "./DedicatedNumberPaymentNotification.vue?vue&type=script&lang=js&"
export * from "./DedicatedNumberPaymentNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442d5e57",
  null
  
)

export default component.exports